<template>
  <DownloadPopup></DownloadPopup>
  <YoutubePopup></YoutubePopup>
  <IframePopup></IframePopup>
  <MobileMenuPopup></MobileMenuPopup>
  <TipsPopup></TipsPopup>
  <WelcomePopup></WelcomePopup>
</template>

<script lang="ts" setup>
import DownloadPopup from '@/components/popup/DownloadPopup.vue';
import YoutubePopup from '@/components/popup/YoutubePopup.vue';
import IframePopup from '@/components/popup/IframePopup.vue';
import MobileMenuPopup from '@/components/popup/MobileMenuPopup.vue';
import TipsPopup from '@/components/popup/TipsPopup.vue';
import WelcomePopup from '@/components/popup/WelcomePopup.vue';
</script>
